<template>
  <div class="ion-page">
    <ion-header translucent>
      <ion-toolbar>
        <ion-title>Settings</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-grid>
        <ion-row>
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-button
              expand="block"
              color="primary"
              class="ion-no-margin"
              href="mailto:kars.v.iersel@gmail.com"
              >Meld een probleem</ion-button
            >
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-button
              expand="block"
              color="tertiary"
              class="ion-no-margin"
              href="mailto:kars.v.iersel@gmail.com"
              >Meld een suggestie</ion-button
            >
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-button expand="block" color="danger" class="ion-no-margin" @click="logout()"
              >Afmelden</ion-button
            >
          </ion-col>
        </ion-row>
      </ion-grid>
      <!-- <ion-list>-->
      <!--        <ion-list-header>-->
      <!--          Account-->
      <!--        </ion-list-header>-->
      <!--        <ion-item button>-->
      <!--          <ion-icon slot="start" name="key" color="primary"></ion-icon>-->
      <!--          <ion-label>-->
      <!--            <h3>Account</h3>-->
      <!--          </ion-label>-->
      <!--        </ion-item>-->
      <!--        <ion-item button>-->
      <!--          <ion-icon slot="start" name="notifications-outline" color="primary"></ion-icon>-->
      <!--          <ion-label>-->
      <!--            <h3>Meldingen v1.1</h3>-->
      <!--          </ion-label>-->
      <!--        </ion-item>-->
      <!--        <ion-item button>-->
      <!--          <ion-icon slot="start" name="analytics" color="primary"></ion-icon>-->
      <!--          <ion-label>-->
      <!--            <h3>Data- en opslaggebruik v1.1</h3>-->
      <!--          </ion-label>-->
      <!--        </ion-item>-->
      <!--      </ion-list> -->

      <!--      <ion-list>-->
      <!--        <ion-list-header>-->
      <!--          Personaliseer - v1.1-->
      <!--        </ion-list-header>-->
      <!--        <ion-item button>-->
      <!--          <ion-icon slot="start" name="musical-notes" color="primary"></ion-icon>-->
      <!--          <ion-label>-->
      <!--            <h3>Stem v1.1</h3>-->
      <!--          </ion-label>-->
      <!--        </ion-item>-->
      <!--        <ion-item button>-->
      <!--          <ion-icon slot="start" name="color-palette" color="primary"></ion-icon>-->
      <!--          <ion-label>-->
      <!--            <h3>Kleuren v1.1</h3>-->
      <!--          </ion-label>-->
      <!--        </ion-item>-->
      <!--      </ion-list>-->

      <!-- <Caregiver></Caregiver> -->

      <!-- <Parent></Parent> -->

      <!--      <ion-list>-->
      <!--        <ion-list-header>-->
      <!--          Overig v1.1-->
      <!--        </ion-list-header>-->
      <!--        <ion-item button>-->
      <!--          <ion-icon slot="start" name="help-circle-outline" color="primary"></ion-icon>-->
      <!--          <ion-label>-->
      <!--            <h3>Help v1.1</h3>-->
      <!--          </ion-label>-->
      <!--        </ion-item>-->
      <!--        <ion-item button>-->
      <!--          <ion-icon slot="start" name="heart" color="danger"></ion-icon>-->
      <!--          <ion-label>-->
      <!--            <h3>Deel v1.1</h3>-->
      <!--          </ion-label>-->
      <!--        </ion-item>-->
      <!--      </ion-list>-->
    </ion-content>
  </div>
</template>

<script>
import * as firebase from "firebase/app";

export default {
  name: "more",
  components: {},
  data() {
    return {
      info: null,
      i: 0
    };
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.commit("emptyItems");
          this.$store.commit("emptyUser");
          this.$router.replace("login");
        });
    }
  }
};
</script>
